(function($)
{
	'use strict';

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	$('.mod_iso_cart .action--quantity .widget').each(function() {
		var $widget = $(this);
		var $form = $widget.closest('form');
		var $input = $widget.find('input');

		$widget.find('.quantity__button').click(function() {
			var $button = $(this);
			var value = parseInt($input.val(), 10);
			value = value + ($button.is('.quantity--up') ? 1 : -1);
			if (value < 1) value = 1;
			$input.val(value);
			$input.trigger('change');
			return false;
		});

		$input.on('change keyup', function() {
			$('.mod_iso_cart .action--update').addClass('show');
		});

		$input.on('change', debounce(function() {
			//$form.submit();
		}, 325));
	});

	/**
	 * Zubehör AJAX
	 */
	$('.mod_iso_productlist.accessories-list .product').each(function() {
		var $product = $(this);
		var $submit = $product.find('.add_to_cart');
		var $form = $product.find('form');
		var $count = $('.cart__icon span.count');

		$form.on('submit', function() {
			if ($product.hasClass('in-cart')) {
				return false;
			}

			$product.addClass('submitting');
			$submit.attr('disabled', true);

			var data = $form.serialize();
			data = data + '&' + $submit.attr('name') + '=' + $submit.attr('value');

			var count = parseInt($count.text(), 10);
			$count.text(++count);

			$.ajax({
				url: $form.attr('action'),
				data: data,
				method: 'POST',
				complete: function(xhr, status) {
					if (typeof xhr.getResponseHeader('x-ajax-location') !== 'undefined' && xhr.getResponseHeader('x-ajax-location') !== null) {
						$product.addClass('in-cart');
						$product.removeClass('submitting');
						$submit.removeAttr('disabled');
					}
				}
			});
			return false;
		});
	});

	$('.mod_iso_messages').click(function() {
		$(this).remove();
	});

	$('.mod_iso_productlist.insurance button.add_to_cart').click(function() {
		$(this).addClass('clicked');
	});


	/**
	 * #106
	 */
	var updateFigureMargin = function() {
		$('.mod_iso_productlist.accessories-list').each(function() {
			var $list = $(this);
			var grouped = [];

			$list.find('.product').each(function(i,e) {
				var index = Math.floor(i/2);
				console.log(index);
				if (typeof grouped[index] === 'undefined') {
					grouped[index] = [];
				}
				grouped[index].push(e);
			});

			$.each(grouped, function(i,group) {
				if (group.length < 2) {
					return true;
				}

				var maxOffset = 0;

				$.each(group, function(i,e) {
					var $element = $(e);
					var offset = $element.find('figure').css('margin-top', 0).offset().top - $element.offset().top;
					if (offset > maxOffset) {
						maxOffset = offset;
					}
				});

				$.each(group, function(i,e) {
					var $element = $(e);
					var $figure = $element.find('figure');
					var offset = maxOffset - ($element.find('figure').offset().top - $element.offset().top);
					$figure.css('margin-top', offset + 'px');
				});
			});
		});
	};
	updateFigureMargin();

})(jQuery);
